import {
  Package, BarChart3, ShoppingCart, FileText, FileSpreadsheet,
  Users, Building2, Settings, Layers, TrendingUp, Percent, Truck, Landmark, Coffee, Link2, MessageCircle
} from 'lucide-react';
import { Store } from 'lucide-react';

// Agrupacion visual del menu por area del negocio. El id de cada item es el
// mismo `currentView` que usa el resto de la app -- no renombrar sin revisar
// los `handleViewChange(...)` sueltos en otras vistas.
export const MENU_SECTIONS = [
  {
    label: 'Principal',
    items: [
      { id: 'inicio', label: 'Inicio', icon: BarChart3 },
    ],
  },
  {
    label: 'Comercial',
    items: [
      { id: 'cotizaciones', label: 'Cotizaciones', icon: FileText },
      { id: 'facturas', label: 'Facturas', icon: FileSpreadsheet },
      { id: 'clientes', label: 'Clientes', icon: Users },
      { id: 'empresas', label: 'Empresas', icon: Building2 },
    ],
  },
  {
    label: 'Compras',
    items: [
      { id: 'proveedores', label: 'Proveedores', icon: Users },
      { id: 'facturas-compra', label: 'Facturas de Compra', icon: Truck },
    ],
  },
  {
    label: 'Operaciones',
    items: [
      { id: 'multi-servicios', label: 'Multi-Servicios', icon: Layers },
      { id: 'punto-v', label: 'Punto V', icon: Coffee },
      { id: 'solicitudes-gestion', label: 'Solicitudes', icon: ShoppingCart },
      { id: 'solicitudes', label: 'Servicios', icon: Package },
      { id: 'articulos', label: 'Artículos', icon: Package },
      { id: 'ordenes-entrega', label: 'Órdenes de Entrega', icon: Truck },
      { id: 'maquinas', label: 'Catálogo de máquinas', icon: Store },
    ],
  },
  {
    label: 'Ventas WhatsApp',
    items: [
      { id: 'chats', label: 'Chats', icon: MessageCircle },
    ],
  },
  {
    label: 'Finanzas',
    items: [
      { id: 'conciliacion-bancaria', label: 'Conciliación Bancaria', icon: Landmark },
      { id: 'parametros-fiscales', label: 'Parámetros Fiscales', icon: Percent },
      { id: 'reportes', label: 'Reportes', icon: TrendingUp },
    ],
  },
  {
    label: 'Sistema',
    items: [
      { id: 'usuarios', label: 'Usuarios', icon: Settings },
      { id: 'simcuv', label: 'SIMCUV', icon: Link2 },
    ],
  },
];

// El id de vista del sidebar no siempre coincide con el codigo real de
// `modulos` (ese catalogo lo definio el backend por separado) -- este
// mapeo es el mejor esfuerzo hecho a mano; si un item nuevo no aparece
// aqui se deja visible por defecto (fail-open en el MENU, la ruta real
// igual la bloquea el backend con requierePermiso).
export const VISTA_A_MODULO = {
  inicio: 'dashboard',
  articulos: 'articulos',
  empresas: 'empresas',
  clientes: 'clientes',
  proveedores: 'proveedores',
  'facturas-compra': 'facturas',
  'multi-servicios': 'taller',
  'solicitudes-gestion': 'solicitudes',
  cotizaciones: 'cotizaciones',
  facturas: 'facturas',
  reportes: 'reportes',
  'conciliacion-bancaria': 'tesoreria',
  'parametros-fiscales': 'parametros',
  solicitudes: 'taller',
  usuarios: 'usuarios',
  'ordenes-entrega': 'ordenes_entrega',
  maquinas: 'maquinas',
  'punto-v': 'puntov',
  chats: 'chats',
  simcuv: 'simcuv',
};

// Para el breadcrumb del topbar: dado un currentView, encuentra su seccion y label.
export const findMenuLocation = (viewId) => {
  for (const section of MENU_SECTIONS) {
    const item = section.items.find((it) => it.id === viewId);
    if (item) return { sectionLabel: section.label, itemLabel: item.label };
  }
  return null;
};
